<template>
  <!--
          作者：tao
          时间：2020-12-11
          描述：抽奖码-抽奖码列表
      -->
  <div class="user">

    <!--添加抽奖码-->
    <div class="common-level-rail" style="float: right;">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" v-auth="'/plus/lottery/lottery/add'">添加抽奖码</el-button>
    </div>
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">

        <el-form-item label="是否导出">
          <el-select v-model="formInline.is_export" placeholder="是否导出">
          <el-option label="请选择" value=""></el-option>
            <el-option label="未导出" value="0"></el-option>
            <el-option label="已导出" value="1"></el-option>

          </el-select>
        </el-form-item>

        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item></el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="lottery_id" label="ID" width="80"></el-table-column>
          <el-table-column prop="batch" label="批次"></el-table-column>
          <el-table-column prop="code_num" label="抽奖码数量"></el-table-column>
          <el-table-column prop="is_export" label="是否导出" width="80">
            <template slot-scope="scope">

              <span v-if="scope.row.is_export == 0"><el-button type="success" @click="onExport(scope.row)" v-auth="'/plus/lottery/lottery/export'">导出</el-button></span>
              <span v-if="scope.row.is_export == 1" class="green">已导出</span>
            </template>
          </el-table-column>
          <el-table-column prop="export_time" label="导出时间" width="140">

          </el-table-column>
          <el-table-column prop="create_time" label="添加时间" width="140"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="detailClick(scope.row)" type="text" size="small" v-auth="'/plus/lottery/lottery/detail'">详情</el-button>

            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" @closeDialog="closeDialogFunc($event, 'add')"></Add>

  </div>
</template>

<script>
import LotteryApi from '@/api/lottery.js';
import Add from './Add.vue';
export default {
  components: {
    /*编辑组件*/
    Add
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        is_export:'',
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      /*等级*/
      gradeList: []
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      LotteryApi.lotterylist(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.gradeList = data.data.grade;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let Params = self.formInline;
      self.getTableList();
    },

    /*导出数据*/
    onExport(row) {


      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/plus.lottery.lottery/export?batch='+row.batch;
      
    },


    /*打开添加*/
    addClick() {
      this.open_add = true;
    },


    /*打开编辑*/
    detailClick(row) {
      this.$router.push({
        path: '/plus/lottery/lottery/detail',
        query: {
          batch: row.batch,

        }
      });
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    },

    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          LotteryApi.deleteuser(
            {
              user_id: row.user_id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，用户删除成功',
                  type: 'success'
                });
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/plus/lottery/lottery/index.vue